<div class="clearfix clsNewLoginPage" id="back">
  <div class="clsLoginHeader">
    <div class="navLogoHeader">
      <div class="logoHeader">
        <a class="logo-link">
          <img
            src="../../../../assets/images/WV/wv_logo.png"
 
            class="logo"
            alt="COMET Icon"
          />
        </a>
      </div>
      <h1
        class="clsLoginHeaderText text-center"
        title="Communication & Operations Mobile Engagement Tool"
      >
      Communication & Operations Mobile Engagement Tool
      </h1>
    </div>
  </div>
  <div class="loader-section">
    <em class="fa fa-spinner fa-spin me-2" aria-hidden="true"></em>
    <p class="loader-text">Signing you in, please wait...</p>
  </div>
</div>
